import { SendMailParams } from "./models/mail";
import { environment as env } from '../environments/environment';

export const productionTitle = 'RAGE'
const crewtimeLink = 'https://rage.crewtime.app'
const financeEmail = 'benedictvera9@gmail.com'
const pmEmail = 'gedo.tibor@gmail.com'
export const invoiceMainualLink = 'https://drive.google.com/file/d/1k8LjWIWNp6vGWLEpYoRjzzdjiEuGb8uM/view'
/** Terms & Conditions */
export const generalTCLink = ''

export const config = {
    dev: { name: "TŐKEY Zoltán", email: 'zoltantokey@gmail.com' },
    /** Ha ezek a userek közül van valaki bejelentkezve, 
         * akkor email küldés előtt kérdezz rá, hogy biztos ki akarja-e küldeni. 
         * Jó eséllyel csak tesztelgetünk, és nem akarjuk ténylegesen elküldeni az emailt. */
    DONT_SEND_MAIL: [/^sosandris@gmail.com$/, /@tu.tu$/, /^sergeikov@gmail.com$/, /^zoltantokey@gmail.com$/],
    SHOW_GROWING_OTTA_RATE: false,
    CONFIG_PERSONAL_END_DATES: false,
    HAS_FOREIGN_CREW: false,
    ALLOW_TRAVELDAY: true,

    ALLOW_CREW_MEMBER_EDIT_FEES: true,
    DISABLE_OLD_TS: true,
    DISABLE_OLD_TS_OT: false,
    DISABLE_OLD_TS_PREP_WEEKS: 2 as false | number,
    DISABLE_OLD_TS_SHOOTING_WEEKS: 2 as false | number,
    ALLOW_CREW_MEMBER_EDIT_OT_STEP: false,
    ALLOW_CREW_MEMBER_EDIT_TA_FEE: true,
    ALLOW_CREW_MEMBER_EDIT_CONTRACT_DATES: true,
    ALLLOW_CONTRACT_END_DATE: true,
    ALLOW_PERDIEM: true,
    ALLOW_OT_PERCENT: true,
    OT_PERCENT: 10,
    ALLOW_TA_PERCENT: true,
    TA_PERCENT: 15,
    ALLOW_REST_DAY: true,
    ALLOW_WORK_ON_REST_DAY: true,
    PERDIEM_MULTIPLIER_FOR_REST_DAY: 1,
    HUF_PER_KM: 75,
    REPORT: {
        CURRENCY: 'EUR' as string | undefined,
    },
    
    /** 'fixed-rates': Nem adható meg naponta új árfolyam. Ha több mint 2 pénznem van, akkor csak ez választható, mert a napi árfolyam mentésekor nem adható meg, hogy melyik pénznam árfolyamát mented */
    MULTIPLE_CURRENCIES: 'fixed-rates' as 'fixed-rates' | boolean,

    DISABLED_TS_HISTORY_TEXT: 'Letiltva',
    
    HU: {
        CONTRACT: {
            ENABLE_FILTER_FINANCE_APPROVED: false,
            CONTRACT_GEN_FEATURE: false,
            ALLOW_PROD_MGR_APPROVE_UNSUBMITTED_CONTRACT: true,
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Start Form visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A Start Formodat {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            SEND_MAIL_FOR_APPROVED: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Start Form elfogadva`,
                body: `Kedves Andi!<br><br>A következő Start Formot jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            },
            SEND_MAIL_FINANCE_NOTIF_NEW_POSITION: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Új pozíció jóváhagyva`,
                body: `Sziasztok! <br><br> A következő Start Formot új pozícióval, de megegyező céggel jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            }
        },
        USER: {
            SEND_MAIL_FOR_REG_ACCEPTED: {
                subject: `[${productionTitle}] Regisztráció elfogadva`,
                body: `Kedves {USERNAME}!<br><br>A regisztrációdat elfogadtuk. Kérlek, töltsd ki a start formodat a ${crewtimeLink} címen.<br><br>Köszönjük!<br>CrewTime`,
            },
        },
        TS: {
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Timesheet visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A Timesheetedet {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            MEAL_PENALTY: 'firstValueableOtRate' as 'firstValueableOtRate' | 'setAtProdDeptSf' | false,
            DISPLAY_KM_PARKING_VIGN_IN_CALCULATED_SECTION: true,
            // Ha nem kell pénzügyes jóváhagyás, akkor , 
            ALLOW_SUBMIT_BEFORE_APPROVAL: false,
            WARN_NUM_CONSEQ_DAYS: 6 as number | false,
            HIDE_KM_FEE: false,
            NOTIFY_KM_FEE_ONLY_IF_ELIGIBLE: false,
        },
    },
} as const

export const IS_RAGE = (productionTitle == 'RAGE')